<template>
  <div class="pb-3">
    <organism-qr-access-create-new
      @createSiteAccess="createSiteAccessToApi"
    ></organism-qr-access-create-new>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import mixins from "@/mixins"
import { createNewSiteAccess } from "@/api/module-1/site-access"
import OrganismQrAccessCreateNew from "@/components/organisms/portal/external/qrAccess/OrganismQrAccessCreateNew.vue"

export default {
  name: "QRAccessCreateNew",
  components: { OrganismQrAccessCreateNew },
  mixins: [mixins],
  computed: {
    ...mapGetters("appPermission", ["getIdcId", "getFullName"]),

    idcId() {
      return this.getIdcId
    },
    fullName() {
      return this.getFullName
    },
  },
  created() {
    this.getCustomerData()
  },
  methods: {
    // load data from api
    getCustomerData() {
      this.customerDataFromApi = {
        customerName: this.fullName,
        idcId: this.idcId.toString().padStart(8, "0"),
      }
    },

    async createSiteAccessToApi(requestCreateNewSiteAccess) {
      this.showLoading(true)
      await createNewSiteAccess(requestCreateNewSiteAccess)
        .then((siteAccess) => {
          this.toastSuccess("Site Access created successfully")

          this.$router.push(
            `/web-portal/site-access/${siteAccess.data.siteAccessId}`
          )
        })
        .catch(() => {
          this.toastError("Site Access created failed")
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
